/**
 * Telehealth Feature Module Configuration
 *
 * Configures the telehealth feature for dynamic loading.
 * Persists only provider preferences that should survive browser sessions.
 */

import type { FeatureModule } from '@store/features/types';
import storage from 'redux-persist/lib/storage';

import waitingRoomReducer from '../waiting-room/store/slice';
import { waitingRoomStreamingApi } from '../waiting-room/store/streamingApi';

import telehealthReducer from './slice';

export const telehealthFeature: FeatureModule = {
  id: 'telehealth',
  name: 'Telehealth Video Conferencing',

  dependencies: [],

  reducers: {
    telehealth: telehealthReducer,
    waitingRoom: waitingRoomReducer,
    [waitingRoomStreamingApi.reducerPath]: waitingRoomStreamingApi.reducer,
  },

  middleware: [waitingRoomStreamingApi.middleware],

  persistence: {
    enabled: true,
    storage,
    whitelist: ['preferences'],
  },

  sync: {
    enabled: false,
  },

  setup: _store => {
    // Feature initialization
  },

  cleanup: _store => {
    // Cleanup logic if needed
  },
};
